import script from "./ProductCardDDB.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCardDDB.vue?vue&type=script&setup=true&lang=js"

import "./ProductCardDDB.vue?vue&type=style&index=0&id=12b73d7b&scoped=true&lang=css"
import "./ProductCardDDB.vue?vue&type=style&index=1&id=12b73d7b&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b73d7b"]])

export default __exports__